import React, { useState } from 'react';

const BetaPasswordModal = ({ onSuccess, onClose, targetLoginType }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const BETA_PASSWORD = 'CompC4bBetaPa$$word12345!';

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    setTimeout(() => {
      if (password === BETA_PASSWORD) {
        sessionStorage.setItem('betaAccess', 'true');
        onSuccess(targetLoginType);
      } else {
        setError('Invalid password');
      }
      setLoading(false);
    }, 500);
  };

  return (
    <div className="beta-overlay" onClick={onClose}>
      <div className="beta-modal" onClick={(e) => e.stopPropagation()}>
        <button className="beta-close" onClick={onClose}>×</button>
        
        <div className="beta-icon-wrapper">
          <span>🔐</span>
        </div>
        
        <h2>Beta Access</h2>
        <p>Enter password to continue</p>

        <form onSubmit={handleSubmit}>
          {error && <div className="beta-error">{error}</div>}
          
          <div className="beta-input-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              name="betaPassword"
              placeholder="Enter beta password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="off"
              required
              autoFocus
            />
            <button 
              type="button" 
              className="beta-eye"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? '👁️' : '👁️‍🗨️'}
            </button>
          </div>

          <button 
            type="submit" 
            className="beta-submit"
            disabled={loading || !password}
          >
            {loading ? 'Verifying...' : 'Continue'}
          </button>
        </form>

        <a 
          href="https://wa.me/27670187407?text=Hi%2C%20I%27d%20like%20beta%20access%20for%20CompanionCab" 
          target="_blank" 
          rel="noopener noreferrer"
          className="beta-help"
        >
          Need access? Contact us
        </a>
      </div>
    </div>
  );
};

export default BetaPasswordModal;
